import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {
    AccountingMovementModel,
    MovementCreating
} from '../../modules/accounting/movement/api/entity/accountingMovement.model';

@Injectable()
export class MovementService {
    private static readonly ROOT_PATH  = '/v1/accounting/movement';
    private static readonly ROOT_PATH_PLURAL  = MovementService.ROOT_PATH + 's';

    constructor(private httpClient: HttpClient) {}

    create(movementCreating: MovementCreating): Promise<AccountingMovementModel> {
        return this.httpClient.post<AccountingMovementModel>(
            environment.webserviceUrl + MovementService.ROOT_PATH_PLURAL, movementCreating).toPromise();
    }

    delete(id: number): Promise<void> {
        return this.httpClient.delete<void>(environment.webserviceUrl + MovementService.ROOT_PATH + '/' + id).toPromise();
    }
}

